"use strict";

var notifyWidget = function () {
  var messageTemplate = '';
  var notifyWidgetParams = {
    model: {},
    url: {},
    template: {},
    needLoad: {}
  };

  function renderUnreadMssgs(data) {
    var $mssgsListWrap = $('.popup .mssgs-list-wrap');

    if (data.Messages.length) {
      var template = messageTemplate.render(data);
      $('.popup .mssgs-list').html(template).show();
    } else {
      $mssgsListWrap.addClass('-empty');
    }
  }

  function getUnreadMssgs(callback) {
    $.ajax({
      url: notifyWidgetParams.url.getMssgs,
      type: 'GET',
      success: function success(data) {
        callback(data);
      }
    });
  }

  function hideMssgPopup(e) {
    var $popup = $('#mssgNotifyLink > .popup');
    var $popupBtn = $('.account-menu-mssgs');
    var $mssgsListWrap = $popup.find('.mssgs-list-wrap');

    if (!$popup.is(e.target) && $popup.has(e.target).length === 0 && !$popupBtn.is(e.target) && $popupBtn.has(e.target).length === 0) {
      $popup.hide();
      $mssgsListWrap.removeClass('-empty');
    }
  }

  function unbindHandlers() {
    $(document).off('mouseup', hideMssgPopup);
    $(document).off('click', '.account-menu-mssgs');
    $(document).off('click', '.popup-close');
  }

  function bindHandlers() {
    $(document).on('mouseup', hideMssgPopup);
    $(document).on('click', '.account-menu-mssgs', function () {
      var $this = $(this);
      var $popup = $this.parent().next('.popup');
      var $loader = $popup.find('.loader');
      $popup.show();

      if (notifyWidgetParams.needLoad) {
        $loader.show();
        getUnreadMssgs(function (data) {
          $loader.hide();
          renderUnreadMssgs(data);
        });
      } else {
        renderUnreadMssgs({
          Messages: []
        });
      }
    });
    $(document).on('click', '.popup-close', function () {
      var $this = $(this);
      var $mssgsListWrap = $('.popup .mssgs-list-wrap');
      $this.closest('.popup').hide();
      $mssgsListWrap.removeClass('-empty');
    });
  }

  function setParams(notifyParams) {
    notifyWidgetParams = $.extend({}, notifyWidgetParams, notifyParams);
  }

  function compileTemplates() {
    messageTemplate = Hogan.compile(notifyWidgetParams.template.mssg);
  }

  function init(notifyParams) {
    unbindHandlers();
    setParams(notifyParams);
    compileTemplates();
    bindHandlers();
  }

  return {
    init: init
  };
}();